import React from "react";
import { Flex, Box } from "grid-styled";
import Button from "../Button";
import InputContainer from "../forms/InputContainer";
import DatePicker from "../forms/DatePicker";
import moment from "moment";
import { handleDateFilterChange } from "../../utils/helpers";
import { getReport, downloadReport } from "../../api";
import ReportView from "../ReportView";
import CenteredLoader from "../CenteredLoader";

class DailySalesReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      downloading: false,
      data: null,
      startDate: moment().subtract(30, "day"),
      endDate: moment()
    };
  }

  componentDidMount() {
    this.fetchReport();
  }

  getQueryParams() {
    const { startDate, endDate } = this.state;
    return {
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      franchise_id: this.props.franchiseId
    };
  }

  fetchReport() {
    this.setState({ loading: true });
    return getReport("daily_sales", this.getQueryParams()).then(report => {
      this.setState({
        data: report,
        loading: false
      });
    });
  }

  handleCSVDownload = evt => {
    evt.preventDefault();
    this.setState({ downloading: true });
    downloadReport("daily_sales", {
      query: this.getQueryParams(),
      filename: "Daily Sales"
    }).then(() => {
      this.setState({ downloading: false });
    });
  };

  handleDateChange = field => newMoment => {
    handleDateFilterChange(
      {
        component: this,
        field,
        newMoment
      },
      () => {
        this.fetchReport();
      }
    );
  };

  renderReport() {
    const { loading, data } = this.state;
    if (loading) return <CenteredLoader />;
    return data && <ReportView data={data} />;
  }

  render() {
    return (
      <Box p={3}>
        <Flex w={1} pb={3}>
          <Box pr={2}>
            <InputContainer
              name="startDate"
              labelText="Start Date"
              value={this.state.startDate}
              onChange={this.handleDateChange("startDate")}
              fieldComponent={DatePicker}
            />
          </Box>
          <Box pl={2}>
            <InputContainer
              name="endDate"
              labelText="End Date"
              value={this.state.endDate}
              onChange={this.handleDateChange("endDate")}
              fieldComponent={DatePicker}
            />
          </Box>
          <Flex ml="auto" align="flex-end" justify="flex-end">
            <Button onClick={this.handleCSVDownload}>
              {this.state.downloading ? "Downloading CSV..." : "Download CSV"}
            </Button>
          </Flex>
        </Flex>
        {this.renderReport()}
      </Box>
    );
  }
}

export default DailySalesReport;



// WEBPACK FOOTER //
// ./src/components/reports/DailySalesReport.js